import classNames from 'classnames'
import { Container } from 'components/common/Containers/Container/Container'
import { FlexColumn } from 'components/common/Containers/FlexColumn/FlexColumn'
import { H4 } from 'components/common/Texts/H4/H4'
import React, { ReactNode } from 'react'
import styles from './Why.module.scss'

interface Props {
  className?: string
  title: ReactNode
  content: ReactNode
}

const Why: React.FC<Props> = ({ title, content, className }) => {
  return (
    <Container>
      <FlexColumn className={classNames(styles.why, className)} gap="1rem">
        <H4>{title}</H4>
        <p>{content}</p>
      </FlexColumn>
    </Container>
  )
}

export default Why
